import { RiEyeOffLine } from "@remixicon/react";
import { Button } from "@screener/uikit/components/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@screener/uikit/components/tooltip";

/**
 * Значок «Скрыть монету» в шапке карточки (§75 п. 2). Часть экрана, не UIKit:
 * знает про монету. Скрывает монету карточки целиком, на всех биржах и рынках,
 * без подтверждения; вернуть её можно только из листа «Скрытые монеты».
 * Подсказка и текстовая альтернатива называют действие и монету.
 */

/** Подпись значка: действие и монета (по базе, а не по тикеру биржи). */
export function cardHideButtonLabel(base: string): string {
  return `Скрыть монету ${base}`;
}

interface CardHideButtonProps {
  base: string;
  onClick: () => void;
}

export function CardHideButton({ base, onClick }: CardHideButtonProps) {
  const label = cardHideButtonLabel(base);
  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Button
            type="button"
            variant="ghost"
            size="icon-cell"
            aria-label={label}
            className="text-muted-foreground"
            onClick={onClick}
          />
        }
      >
        <RiEyeOffLine aria-hidden="true" />
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}
